import { BrowserCacheLocation } from '@azure/msal-browser';
import { createSiQuoteUrls } from './api-urls';

export const version = '7.3.2.6 W'; // Keep this version in sync with ET Desktop's version.
export const webVersion = '1.0'; // Update this version for each PROD deployment to ensure proper version tracking.

export const environment = {
  production: false,
  reportMessaging: {
    // Set deployed UI origin(s), e.g. https://app.company.com
    allowedOrigins: ['https://siquote-web-prod.azurewebsites.net', 'https://siquote-gateway-api-prod.azurewebsites.net', 'https://et-si-quote.siemens.com']
  }
};

// Primary host; fallback is used automatically when the app is loaded from it.
const PRIMARY_ORIGIN = 'https://et-si-quote.siemens.com';
const FALLBACK_ORIGIN = 'https://siquote-web-prod.azurewebsites.net';
const ALLOWED_ORIGINS = [PRIMARY_ORIGIN, FALLBACK_ORIGIN];

const currentOrigin = typeof window !== 'undefined' ? window.location.origin : PRIMARY_ORIGIN;
const activeOrigin = ALLOWED_ORIGINS.includes(currentOrigin) ? currentOrigin : PRIMARY_ORIGIN;

export const loginURI = `${activeOrigin}/`;

export const msalConfig = {
  auth: {
    clientId: 'a91cbf0d-9d2c-4411-9a84-644a254c2337',
    authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
    redirectUri: `${activeOrigin}/dashboard`,
    postLogoutRedirectUri: `${activeOrigin}/login`,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
  scopes:
    [
      'openid',
      'profile',
      'email'
    ]
};

export const apiBaseURI = 'https://siquote-gateway-api-prod.azurewebsites.net'; // Base API URL

export const siQuoteUrls = createSiQuoteUrls(apiBaseURI);